import { render, staticRenderFns } from "./WechatAgreement.vue?vue&type=template&id=367060a8&"
import script from "./WechatAgreement.vue?vue&type=script&lang=js&"
export * from "./WechatAgreement.vue?vue&type=script&lang=js&"
import style0 from "./WechatAgreement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports